"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Elasticity report about a group of products. For each product, returns ElasticityProductData structure, which in turn contains
 * reported data at different price points, in terms of ElasticityProductPriceData.
 *
 * @author Michal Sevcenko
 */


var ElasticityReport =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ElasticityReport, _DomainObject_1$Domai);

  function ElasticityReport(message, results) {
    var _this;

    _classCallCheck(this, ElasticityReport);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ElasticityReport).call(this));
    _this.message = message;
    _this.results = results;
    return _this;
  }

  return ElasticityReport;
}(DomainObject_1.DomainObject);

exports.ElasticityReport = ElasticityReport;